module.exports = {
   components: [],
   routes: [],
   sub_routes: [{
         name: "Dashboards",
         path: "visuals/dashboard",
         component: () => import('./dashboard/dashboard.vue'),
      },
      {
         name: "Visuals",
         path: "visuals/visuals",
         component: () => import('./visuals/visuals.vue'),
      },
      {
         name: "Dashboards-View_Dashboard",
         path: "visuals/dashboard-visuals/:dashboard_id",
         component: () => import('./dashboard/view-dashboard'),
      },
   ]
}